// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"25":"e73ecccee29b062d","888":"7ec9b41089bc8b7c"}[chunkId] + ".css";
};